import request from 'assets/js/http';

export function notifyRead(ids) {
  // 我的消息-已读设置
  return request({
    url: '/notify/read',
    method: 'post',
    data: { ids }
  });
}
export function notifyReadAll(type) {
  // 阅读全部
  return request({
    url: '/notify/readAll',
    method: 'post',
    data: { type }
  });
}

export function notifyCount(data) {
  // 我的消息-数量(已读未读等）
  return request({
    url: '/notify/count',
    method: 'post',
    data
  });
  /*type	string	是	消息类型 -1或空 不分类	-1
  isRead	string	是	是否已读 0未读 1已读 空不区别	0*/
}
export function notifyList(data) {
  // 我的消息-已读设置
  return request({
    url: '/notify/list',
    method: 'post',
    data
  });
}
